export default __webpack_public_path__ + "static/it4-373ed480995b255824147c64c399cba7.jpg";